import React, { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import Spinner from '../../assets/images/Spinner.svg';

import api from '../../services/api';

const Home = (props) => {
  const params = new URLSearchParams(props.location.search);

  const [loading, setLoading] = useState(false);

  const history = useHistory();

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  };

  let query = useQuery();
  let id_company = query.get("id_company");
  let id_contact = query.get("id_contact");
  let id_user = query.get("id_user");

  const getPersonDigisac = async () => {
    setLoading(true);
    const response = await api.get('/person/id?id_company=' + id_company + '&id_contact=' + id_contact + '&id_user=' + id_user);
    if(response.data){
      setLoading(false);
      localStorage.setItem('person_id', response.data.id);

      history.push('/business');
    } else if(!response.data.id){
      setLoading(false);
      history.push('/person');
    }
  }

  const getEmail = async () => {
    setLoading(true);
    const response = await api.get('/email/list?id_company=' + id_company + '&id_contact=' + id_contact + '&id_user=' + id_user);
    if(response.data){
      setLoading(false);
      localStorage.setItem('email_user', response.data);
      getPersonDigisac()

    } else if(!response.data){
      setLoading(false);
      history.push('/email');
    }
  }

  useEffect(() => {

    localStorage.setItem('followize_id_company', params.get('id_company')?.toString() || '');
    localStorage.setItem('followize_id_contact', params.get('id_contact')?.toString() || '');
    localStorage.setItem('followize_id_user', params.get('id_user')?.toString() || '');

    getEmail()

  }, [])

  return (<>
      {loading ? <img src={Spinner} alt="Teste" style={{ width: 100, display:'flex', marginTop: '300px', marginLeft: '150px'}}></img> : false}
    </>
  )
}

export default Home